var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeBlue = function SvgEyeBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_878102_cc",
    width: 18.541,
    height: 10.519,
    viewBox: "0 0 18.541 10.519",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M31.07,34a11.149,11.149,0,0,0-9.27,5.26,11.144,11.144,0,0,0,9.27,5.26,11.148,11.148,0,0,0,9.27-5.26A11.142,11.142,0,0,0,31.07,34Zm4.6,5.26a4.6,4.6,0,1,1-4.6-4.6A4.616,4.616,0,0,1,35.673,39.26Zm-13.084,0a11.367,11.367,0,0,1,5.062-3.978,5.218,5.218,0,0,0,0,7.955A11.368,11.368,0,0,1,22.589,39.26Zm11.9,3.978a5.218,5.218,0,0,0,0-7.955,11.581,11.581,0,0,1,5.062,3.978A11.368,11.368,0,0,1,34.489,43.237ZM29.1,39.26a1.972,1.972,0,1,1,1.972,1.972A1.978,1.978,0,0,1,29.1,39.26Z",
    transform: "translate(-21.8 -34)",
    fill: "#07a3c8"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eyeBlue.06725d8a.svg";
export { ForwardRef as ReactComponent };